import { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  ModalContext,
  AlloyButton,
  ChevronRightIcon
} from 'cat-ecommerce-alloy';
import { navigateToUrl } from '../../../../../services/windowService';
import SaveEquipment from '../../../../pages/my-equipment/AddEquipmentModal/SearchSuggestions/EquipmentSuggestions/SaveEquipment';
import cx from 'classnames';
import pmStyles from '../PMKitWidget.scss';
import useEquipmentDrawer from '@app/hooks/useEquipmentDrawer';

const FooterLinksAndButtons = ({
  isDataLoaded,
  isMachineLandingPage,
  pmKitLearnMoreLink,
  serialNumber,
  myEquipmentList,
  selectedEquipment,
  widgetIdentifier,
  isCEModel,
  openAddDrawer,
  openEditDrawer
}) => {
  const [t] = useTranslation();
  const modalCtx = useContext(ModalContext);
  const { openSelectDrawer, getDrawerComponent } = useEquipmentDrawer();

  const { isQRCodeTempEquipment } = selectedEquipment;

  const modalTitle = t('SAVE_MY_EQUIPMENT');
  const buttonTitle = isQRCodeTempEquipment
    ? t('MEQ_SAVE_EQUIP')
    : t('MEQ_EDIT_EQUIP');
  const defaultProps = {
    modalTitle,
    widgetIdentifier,
    currentEquipment: selectedEquipment
  };
  const openModal = () => {
    isQRCodeTempEquipment
      ? modalCtx.addModalWithOptions(
          <SaveEquipment
            {...defaultProps}
            isTempEquipmentMessage={isQRCodeTempEquipment ?? false}
          />,
          modalTitle
        )
      : openEditDrawer();
  };
  let meqButton;
  if (serialNumber) {
    if (myEquipmentList.length === 1) {
      meqButton = (
        <AlloyButton
          buttonType="ghost"
          size="small"
          className="p-0"
          onClick={openAddDrawer}
        >
          <span className="btn__icon-right">
            {t('ADD_EQUIPMENT_ICON')}
            <ChevronRightIcon className="ms-2" />
          </span>
        </AlloyButton>
      );
    } else if (myEquipmentList.length > 1) {
      meqButton = (
        <AlloyButton
          buttonType="ghost"
          size="small"
          className="p-0"
          onClick={openSelectDrawer}
        >
          <span className="btn__icon-right">
            {t('CHANGE_EQUIPMENT')}
            <ChevronRightIcon className="ms-2" />
          </span>
        </AlloyButton>
      );
    }
  } else {
    meqButton = (
      <AlloyButton
        buttonType="ghost"
        size="small"
        className="p-0"
        onClick={openModal}
      >
        <span className="btn__icon-right">
          {buttonTitle}
          <ChevronRightIcon className="ms-2" />
        </span>
      </AlloyButton>
    );
  }

  return (
    <div
      className={cx(
        pmStyles['pm-kit-btn'],
        'd-flex justify-content-between mb-3',
        { 'ms-0': isDataLoaded || (isCEModel && !serialNumber) }
      )}
    >
      <div>{meqButton}</div>
      <div className={`${pmStyles['btn-learn-more']}`}>
        {isMachineLandingPage && (
          <AlloyButton
            buttonType="ghost"
            size="small"
            className="p-0"
            onClick={() => navigateToUrl(pmKitLearnMoreLink)}
          >
            <span className="btn__icon-right">
              {t('PM_KIT_UI4')}
              <ChevronRightIcon className="ms-2" />
            </span>
          </AlloyButton>
        )}
        {getDrawerComponent({
          currentEquipment: selectedEquipment,
          myEquipmentList: myEquipmentList
        })}
      </div>
    </div>
  );
};

FooterLinksAndButtons.propTypes = {
  isMachineLandingPage: PropTypes.bool,
  isDataLoaded: PropTypes.bool,
  serialNumber: PropTypes.string,
  pmKitLearnMoreLink: PropTypes.string,
  myEquipmentList: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string]))
  ),
  storeId: PropTypes.string,
  selectedEquipment: PropTypes.shape({
    unValidatedEquipmentId: PropTypes.string,
    model: PropTypes.string,
    assetId: PropTypes.string,
    productId: PropTypes.string,
    equipmentFamily: PropTypes.string,
    uniqueIndex: PropTypes.string,
    serialNumber: PropTypes.string,
    validatedAsset: PropTypes.bool,
    imageURL: PropTypes.string
  }),
  widgetIdentifier: PropTypes.string,
  isCEModel: PropTypes.bool,
  openAddDrawer: PropTypes.func,
  openEditDrawer: PropTypes.func
};

export default FooterLinksAndButtons;
